import "./App.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesComponent from "./components/RoutesComponent";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from "react";
import WebFont from "webfontloader";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AuthProvider } from "./hooks/context/AuthContext";
import { ToastContextProvider } from "./hooks/context/ToastContext";
import "./assets/css/devStyles.css";
import InstallPWA from "./components/shared/buttons/installPwa";

function App() {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Nunito:300,400,700"], // Specify the weights you need
      },
    });
  }, []);
  return (
    <div className="App">
      <Router>
        <ToastContextProvider>
          <AuthProvider>
            <InstallPWA />
            <RoutesComponent />
          </AuthProvider>
        </ToastContextProvider>
      </Router>
    </div>
  );
}

export default App;
